if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        /* Pre-warm the active image fetch BEFORE the modal becomes visible.
           Browsers don't lazy-load <img> inside display:none ancestors, so the high-res
           image only starts downloading after we toggle .active. Triggering a fetch via
           new Image() puts the resource in the HTTP cache so the swap is instant. */
        const targetId = opener.getAttribute('data-media-id');
        const targetMedia = targetId && this.querySelector(`[data-media-id="${targetId}"]`);
        const targetImg = targetMedia && targetMedia.querySelector('img');
        if (targetImg) {
          const url = targetImg.currentSrc || targetImg.getAttribute('src') || targetImg.dataset.src;
          if (url) {
            const preload = new Image();
            try { preload.fetchPriority = 'high'; } catch (e) {}
            preload.decoding = 'async';
            preload.srcset = targetImg.getAttribute('srcset') || '';
            preload.sizes = targetImg.getAttribute('sizes') || '';
            preload.src = url;
          }
          targetImg.loading = 'eager';
          targetImg.setAttribute('fetchpriority', 'high');
        }

        super.show(opener);
        /* Wait one frame so the modal is in the box-tree before we measure + scroll */
        requestAnimationFrame(() => this.showActiveMedia());
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        /* Use instant scroll — Dawn's component-slider.css sets scroll-behavior: smooth
           on slider-component which makes scrollIntoView animate slowly here */
        activeMedia.scrollIntoView({ behavior: 'instant', block: 'start' });

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
